export default __webpack_public_path__ + "static/media/about3.450b2da7.png";